import { render, staticRenderFns } from "./OpportunityListByDate.vue?vue&type=template&id=67da3a18&"
import script from "./OpportunityListByDate.vue?vue&type=script&lang=js&"
export * from "./OpportunityListByDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports